const initState =
{

}

const notificationsReducer = (state = initState, action) => {
    return state;
}
export default notificationsReducer